import { PageViewEventLogger } from '@repo/tracking-service';
import { SignBackButtonLayout, SignUpInput } from '@repo/user-sign';
import { ReactElement } from 'react';

export const SignUpInputPage = () => {
  return (
    <>
      <SignUpInput />
      <PageViewEventLogger pageName={'sign-up-input'} />
    </>
  );
};

SignUpInputPage.getLayout = (page: ReactElement) => <SignBackButtonLayout>{page}</SignBackButtonLayout>;

export default SignUpInputPage;
